export default __webpack_public_path__ + "static/media/phocles.7c7cdd20.svg";